module.exports = __webpack_public_path__ + "img/660.c64061a7.png";